import React, { Component } from "react";
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { RequestHeaders } from "../../../common/header-logo/request-header.component";
import '../../../common/report/reports/Invoice/invoice-table.component.css';
import '../inventory-component.css';
import { NoSubscription } from "../../dashboard/no-subscription/no-subscription.component";
import { ACCESS_MODULE, MATRIX_INDICATOR } from "../../../../utils/rbac-constants.utils";
import { validateAccessModule } from "../../../../utils/helpers.utils";
import InventoryDetails from "../DetailsView/inventory-details-view.component";
import { BrowserRouter, Switch, Route } from 'react-router-dom';
import CreateRequestDisplay from '../../request/create-request/create-request-modal-display.component';
import Translation from "../../../common/translation/translation.component";
import RequestDetailDisplay from "../../request/request-details/request-details-modal-display.component";
import { inventoryCostAllocationActions } from '../../../../store/external/inventory/add-cost-allocation.reducer';
import { TablePagination } from "../../../common/details-table/table-pagination.component";
import { inventoryCircuitActions } from "../../../../store/external/inventory/circuit.reducer";
import { ConfirmationNotificationModal } from "../../../common/modal/confirmation-modal.component";
import { DetailsDashboard } from "../../../common/details-dashboard/details-dashboard-layout";
import { Selected_Index, TABLE_PAGINATION_KEY } from "../../../../constants/external-constants";

class InventoryCircuitPage extends Component {
    constructor(props) {
        super(props);
        this.DisplaySearhBox=this.DisplaySearhBox.bind(this)
        this.openLineItem=this.openLineItem.bind(this)
        // this.GetItemClick = this.GetItemClick.bind(this)
        this.onClickExtract = this.onClickExtract.bind(this)
        this.state = {
            circuitId: 0,
            modifyColTitle: '',
            extractInventoryTitle: '',
            searchTitle: '',
            extractAlertMsg: "",
            tableSelected:false,
            closeForm:false,
            rowId:"0",
            pageNumber:0,
			viewType:'list',
            displaySearch:false,
            selectedIndex:0,
            dataSelected: [],
            viewDetailPage:false,
            selectedCircuit: undefined,
            headerTitle:"circuit",
            createNew:false,
            showModal: false,
            listTabInfo: {
                Tab: [
                    {
                        "id": "0",
                        "label": "Subscription Details"
                    },
                    {
                        "id": "1",
                        "label": "Usage Spend"
                    }
                ]
            },
            extractOption:[
                {
                    "id":0,
                    "label":"Extract List"
                },
                {
                    "id":1,
                    "label":"Inventory Report"
                },
                {
                    "id":2,
                    "label":"Device Listing Report"
                }
            ]
        }
    }

    componentDidMount() {
        this.props.getInventoryCircuit();
        this.changeHeaderTitle();
    }
    componentWillUnmount(){
        // this.props.setResetSearch();
        // this.props.resetInventoryCircuitData();
        this.props.getInventoryCircuit(0, true)
    }
    DisplaySearhBox() {
        this.setState({displaySearch:!this.state.displaySearch})
    }

    openLineItem(data) {
        this.setState({tableSelected:data})
    }

    CloseForm(data) {
        this.setState({tableSelected:data})
    }

    // GetItemClick(value) {
    //     this.setState({rowId:value})    
        
    //    inventoryData.map((dataList)=>
    //         this.setState({dataSelected:dataList.Data.Items.filter((_,i)=>i===value)})
    //    )
    // }

    getDataSelected(data) {
        this.setState({selectedIndex:data})
        
    }

    resizePage = (value) => {
        const { getInventoryCircuit, resizeInventoryCircuitPage } = this.props;
        resizeInventoryCircuitPage(value);
        getInventoryCircuit();
    }

    onClickExtract = (id) => {
        if (window.confirm(this.state.extractAlertMsg)) {
            this.props.extractInventoryCircuits(id);
        }
    }

    onChangeExtractAlertMsg = (val, key) => {
        this.setState({
            extractAlertMsg: val
        });
    }

    loading = () => {
        return (
           <NoSubscription />
        );
    }

    applyFilter = (isApply) => {
        const { getInventoryCircuit, applyInventoryCircuitFilter } = this.props;
        applyInventoryCircuitFilter(isApply);
        isApply && getInventoryCircuit(0);
    }

    getData = (isShow, rowItem) => {     
        const { getInventoryCircuitDetail} = this.props;

        if (rowItem != null) {
            var circuitId = rowItem.CircuitId;
            var circuitTypeId = rowItem.CircuitTypeID; 
            var billingAccountId = rowItem.AccountID; 

            this.setState({ 
                viewDetailPage: isShow
                , circuitId: rowItem.CircuitId
                , selectedCircuit: rowItem
            })
            this.setState({ viewDetailPage: isShow },()=>(
                this.changeHeaderTitle()
            ))
            getInventoryCircuitDetail(circuitId, circuitTypeId, billingAccountId);            
        }
        else {
            this.setState({ viewDetailPage: isShow, createNew: false },()=>(
                this.changeHeaderTitle()
            ))
        }
        
    }

    changeHeaderTitle(){
        if(this.state.viewDetailPage || this.state.createNew) {
            this.setState({headerTitle:"circuit_details"})
        } else {
            this.setState({headerTitle:"circuit"})
        }
    }

    handelCreateNew(){        
        this.setState({
            showModal: true,
        })
     }

    handleCreateNew(buttonType){
        if(buttonType==="ok")
        {
            this.setState({
                selectedCircuit: undefined,
                circuitId: 0,
                createNew: !this.state.createNew,
                showModal: false
            }, this.changeHeaderTitle);
        } else {
            this.setState({showModal: false })
        }
       
     }

     handleOptionClick=(id)=>{
       if(id===parseInt(Selected_Index.i_Zero)) {
         this.onClickExtract(id)
       } else if(id===parseInt(Selected_Index.i_One)) {
         this.onClickExtract(id)
       } else if(id===parseInt(Selected_Index.i_Two)) {
         this.onClickExtract(id)   
       }
     }

    render() {        
        const { inventoryCircuit, getInventoryCircuit, sortInventoryCircuitItems, setInventoryCircuitColSearchStr, addInventoryCircuitFilter, removeInventoryCircuitFilter, saveInventoryCircuitCustomCols } = this.props;
        const { Selected, Available, Default } = this.props.inventoryCircuit.inventoryCircuitItems.Columns;
        
        let isReadOnly = !validateAccessModule(MATRIX_INDICATOR.MatrixId, [ACCESS_MODULE.InventoryCircuitR])
        let isReadAndExtractOnly = !validateAccessModule(MATRIX_INDICATOR.MatrixId, [ACCESS_MODULE.InventoryCircuitRE])
        let isReadAndWrite = !validateAccessModule(MATRIX_INDICATOR.MatrixId, [ACCESS_MODULE.InventoryCircuitRW])
        
        return(
            <div className="invoice-wrapper-container inventory-report-component" >
                <Translation
                    getOnlyText={true}
                    onChangeTranslation={this.onChangeExtractAlertMsg}
                    translationKey={"export_alert_message"} />
                <RequestHeaders headerTitle={this.state.headerTitle} />
                <ConfirmationNotificationModal 
                    show={this.state.showModal} 
                    message={'Do you want to create new circuit?'} 
                    title={'Add New'}
                    handleModal={this.handleCreateNew.bind(this)}
                    customClass={'comment-notification-modal modal-text-bold'}
                />
                <div className={`request-table data-table ${this.state.viewDetailPage ? "" : "fit-width"}`}>
                    {
                        this.state.viewDetailPage || this.state.createNew ?
                            <BrowserRouter>
                                <Switch>
                                    <InventoryDetails
                                        closeForm={this.getData.bind(this)}
                                        history={this.props.history}
                                        circuitId={this.state.circuitId}
                                        selectedCircuit={this.state.selectedCircuit}
                                        isCreateNew={this.state.createNew}

                                        //Access Type
                                        isReadOnly={isReadOnly}
                                        isReadAndExtractOnly={isReadAndExtractOnly}
                                        isReadAndWrite={isReadAndWrite}
                                     >
                                        <Route exact path="/external/Inventory/Circuit/MyRequest/RaiseRequest/Order/:id" component={CreateRequestDisplay} />
                                        <Route exact path="/external/Inventory/History/MyRequest/RequestDetail/Order/:id" component={RequestDetailDisplay} />  
                                    </InventoryDetails>
                                </Switch>
                            </BrowserRouter>
                            :
                            <>
                                <DetailsDashboard
                                    // Filter Properties
                                    data={inventoryCircuit.inventoryCircuitItems.TableFilterData} 
                                    translation={this.state.translation} addAction={addInventoryCircuitFilter} 
                                    removeAction={removeInventoryCircuitFilter} applyAction={this.applyFilter}

                                    //CreateNew Action
                                    createNewAction={this.handelCreateNew.bind(this)}

                                    //View Search Textbox
                                    viewSearchAction={this.DisplaySearhBox}

                                    //Customize Column
                                    firstList={Available} 
                                    secondList={Selected} 
                                    defaultList={Default} 
                                    saveAction={saveInventoryCircuitCustomCols}

                                    //Extract Button
                                    extractAction={(e)=> this.onClickExtract(e)}
                                    
                                    //Access Type
                                    isReadOnly={isReadOnly}
                                    isReadAndExtractOnly={isReadAndExtractOnly}
                                    isReadAndWrite={isReadAndWrite}

                                    //Dropdown Extract List
                                    dropdownExtract={true}
                                    extractListLabel="Extract List"
                                    buttonIcon="cloud-arrow-down"
                                    options={this.state.extractOption}
                                    onSelect={this.handleOptionClick}
                                >
                                {
                                    inventoryCircuit.isInventoryCircuitLoaded ? 
                                    <TablePagination  
                                        key={TABLE_PAGINATION_KEY.inventoryCircuit}  
                                        classNameWrapper="overflow-auto" 
                                        columns={inventoryCircuit.inventoryCircuitItems.Headers}
                                        pageList={inventoryCircuit.inventoryCircuitItems.Data}
                                        pages={inventoryCircuit.inventoryCircuitItems.Pagination}
                                        rowClickAction={(value) => { this.getData(true, value) }} 
                                        paginationAction={getInventoryCircuit}
                                        onColumnClick={sortInventoryCircuitItems}
                                        onColumnSearch={() => { getInventoryCircuit(0) }}
                                        onColumnSearchChange={setInventoryCircuitColSearchStr}
                                        isColSearchShow={this.state.displaySearch}
                                        resizePage={this.resizePage}
                                    />
                                    : this.loading()
                                }
                                </DetailsDashboard>
                            </>
                        }
                         
                        
                       
                     </div>             
            </div>
        )
    }
}

export default connect(
    state => {
        const { inventoryCircuit, translation } = state;
        return {
            inventoryCircuit
            , ...translation
        };
    },
    dispatch => bindActionCreators(
        Object.assign({}, inventoryCircuitActions, inventoryCostAllocationActions),
        dispatch
    )
)(InventoryCircuitPage);

